<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">The book I got was what I ordered, but the professor says different materials should be listed for my course</h1>

			<div>
				<h3>Please enter correct ISBN:</h3>
				<v-text-field
						label="ISBN"
						v-model="isbn"
						:rules="isbn_rules"
						mask="#########N###"
						counter="13"
						solo
						flat
						:error-messages="error_messages"
						@focus="error_messages = []"
				></v-text-field>

				<p>
					After submit, you'll have to go through our return process. You will be redirected to it automatically
				</p>

				<v-btn
						color="#7DADED"
						large
						round
						dark
						@click="submit"
				>
					Report
				</v-btn>
			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../../components/BaseNavLinks';
	import Axios from 'axios';

	export default {
		name: "WrongBookNeedOther",

		components: {
			BaseNavLinks,
		},

		data() {
			return {
				isbn: '',
				error_messages: [],
				isbn_rules: [v => v.length == 10 || v.length == 13 || 'Must be 10 or 13 digits']
			}
		},

		methods: {
			submit() {
				const self = this;

				if (!self.isbn) {
					self.error_messages.push("ISBN can't be empty");
					return;
				}

				if (self.isbn.length != 10 && self.isbn.length != 13) {
					return;
				}

				self.loading = true;

				Axios.post('/service/customer_help/rest/index.php/customer_help/send_wrong_adoption_issue_cs_request/', {
					order_line_id: parseInt(self.$route.params.id),
					correct_isbn: self.isbn,
				})
					.then(function (response) {
						if (response.status === 200 && response.data && response.data['status'] === 'success') {
							document.location.href = "/returns";
							return;
						} else {
							if (response.data.result === 'not_valid_isbn') {
								self.error_messages.push(response.data.message);
							}
						}
					})
					.finally(function () {
						self.loading = false;
					});
			}
		},
	}
</script>

<style scoped>

</style>